import { Box, Flex, Text, xcss } from '@atlaskit/primitives';
import { useState } from 'react';
import { H6 } from '../Typography';
import { AccordionItem } from './components/accordion-item';
import { AccordionItemContent } from './components/accordion-item-content';
import { handleKeyDown } from './util';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const descriptionSpacing = xcss({
  marginBlockEnd: 'space.050'
});
const topMargin = xcss({
  marginTop: 'space.100'
});
const accordionTitleSectionSpacings = xcss({
  marginBottom: 'space.050',
  height: '24px'
});
const expandAllBtnStyles = xcss({
  color: 'color.link',
  cursor: 'pointer'
});
const accordionItemsBorderStyles = xcss({
  overflow: 'hidden',
  borderRadius: "var(--ds-radius-small, 4px)",
  border: "1px solid ".concat("var(--ds-border, #091E4224)"),
  marginTop: 'space.100'
});
export const AccordionV2 = _ref => {
  let {
    mainTitle,
    description,
    items,
    showExpandAll = false,
    testId,
    onExpandAll,
    onCollapseAll,
    onExpandItem,
    onCollapseItem,
    headingIds = [],
    mainTitleId
  } = _ref;
  const [expandedKeys, setExpandedKeys] = useState([]);
  const expandItem = targetKey => {
    setExpandedKeys(prev => !prev.includes(targetKey) ? [...prev, targetKey] : prev);
    onExpandItem === null || onExpandItem === void 0 ? void 0 : onExpandItem(targetKey);
  };
  const collapseItem = targetKey => {
    setExpandedKeys(prev => prev.filter(eachKey => eachKey !== targetKey));
    onCollapseItem === null || onCollapseItem === void 0 ? void 0 : onCollapseItem(targetKey);
  };
  const handleExpandAll = accordionItems => {
    if (allExpanded) {
      handleCollapseAll();
    } else {
      setExpandedKeys(accordionItems.map(_ref2 => {
        let {
          key
        } = _ref2;
        return key;
      }));
      onExpandAll === null || onExpandAll === void 0 ? void 0 : onExpandAll();
    }
  };
  const handleCollapseAll = () => {
    setExpandedKeys([]);
    onCollapseAll === null || onCollapseAll === void 0 ? void 0 : onCollapseAll();
  };
  const showExpandAllBtn = showExpandAll && items.length > 1;
  const allExpanded = expandedKeys.length === items.length;
  const expandAllBtnText = allExpanded ? 'Collapse all' : 'Expand all';
  const expandItems = () => {
    handleExpandAll(items);
  };
  const handleExpandAllKeyDown = event => {
    handleKeyDown(event, expandItems);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    direction: "column",
    xcss: topMargin,
    testId: testId,
    children: [/*#__PURE__*/_jsxs(Flex, {
      xcss: accordionTitleSectionSpacings,
      justifyContent: "space-between",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(H6, {
        as: "h2",
        id: mainTitleId,
        children: mainTitle
      }), showExpandAllBtn ? /*#__PURE__*/_jsx(Box, {
        role: "button",
        tabIndex: 0,
        id: "expand-all-button",
        onClick: expandItems,
        onKeyDown: handleExpandAllKeyDown,
        xcss: expandAllBtnStyles,
        "aria-labelledby": "expand-all-button ".concat(mainTitleId || (headingIds === null || headingIds === void 0 ? void 0 : headingIds.join(' '))),
        children: /*#__PURE__*/_jsx(Text, {
          color: "color.link",
          children: expandAllBtnText
        })
      }) : null]
    }), description ? /*#__PURE__*/_jsx(Box, {
      xcss: descriptionSpacing,
      children: description
    }) : null, items.length !== 0 ? /*#__PURE__*/_jsx(Flex, {
      xcss: accordionItemsBorderStyles,
      direction: "column",
      children: items.map(_ref3 => {
        let {
          key,
          heading,
          content,
          testId: itemTestId,
          ariaLabel
        } = _ref3;
        const isItemExpanded = expandedKeys.includes(key);
        return /*#__PURE__*/_jsx(AccordionItem, {
          itemKey: key,
          renderHeader: heading,
          expandItem: expandItem,
          collapseItem: collapseItem,
          isExpanded: isItemExpanded,
          testId: itemTestId,
          ariaLabel: ariaLabel,
          children: /*#__PURE__*/_jsx(AccordionItemContent, {
            itemKey: key,
            children: content()
          })
        }, key);
      })
    }) : null]
  });
};